export default __webpack_public_path__ + "static/media/E-WEB-Goal-04.f8a53f9b.png";